module.exports = __webpack_public_path__ + "img/metTasGroot.92ecfe5d.png";